import React from 'react';

import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { Image, Typography } from '../../../components/atoms';
import { keyFromText } from '../../../utils/makeUtils';

type Props = {
  description: string;
  imageUrl: string;
  name: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  image: {
    boxSizing: 'content-box',
    objectFit: 'cover',

    '& img': {
      height: 'auto',
    },
  },

  name: {
    padding: theme.spacing(2.5, 0, 1.75),
  },

  textContent: {
    padding: theme.spacing(0, 2),

    '& .fd-text': {
      marginBottom: theme.spacing(0.5),
    },
  },

  [theme.breakpoints.up('sm')]: {
    name: {
      fontSize: theme.typography.pxToRem(28),
    },
    textContent: {
      padding: theme.spacing(0, 3),
    },
  },
}));

export function MenuDialogItemDetails(props: Props): JSX.Element {
  const { description, imageUrl, name } = props;
  const classes = useStyles();

  const renderDescription = (): JSX.Element[] => {
    if (!description) {
      return null;
    }

    return description
      .split('\n')
      .filter((line) => line !== '')
      .map((line) => (
        <Typography key={keyFromText(line, 'desc')} variant="body2-secondary">
          {line}
        </Typography>
      ));
  };

  return (
    <div>
      {imageUrl && (
        <Image
          alt={name}
          className={classes.image}
          dimensions={[767, 460]}
          src={imageUrl}
        />
      )}

      <div className={classes.textContent}>
        <Typography className={classes.name} variant="h2">
          {name}
        </Typography>

        {renderDescription()}
      </div>
    </div>
  );
}
